export const APP_DOWNLOAD_URL = 'https://ecbocloak.go.link/ff1OV'
